module.exports = __webpack_public_path__ + "img/blackfriday.f707ee4b.png";